import { getToken, modifyProductList } from "../../helper/common";
import agent from "../services/agent";
// import { clearForm } from "./form.actions";
import {
  CLOSE_CREATE_PRODUCT_MODAL,
  CLOSE_UPDATE_PRODUCT_MODAL,
  CREATE_PRODUCT_ERROR,
  CREATE_PRODUCT_PENDING,
  CREATE_PRODUCT_SUCCESS,
  GET_PRODUCTS_PENDING,
  OPEN_CREATE_PRODUCT_MODAL,
  OPEN_UPDATE_PRODUCT_MODAL,
  SET_PRODUCTS_LIST,
  UPDATE_PRODUCT_ERROR,
  UPDATE_PRODUCT_PENDING,
  UPDATE_PRODUCT_SUCCESS,
  SET_PRODUCT_DETAILS,
  SET_ASSIGNABLE_PRODUCTS_LIST_ASYNC,
  ADD_PRODUCT,
  PRODUCT_LIST_ERROR,
  CLEAR_UPDATE_PRODUCT_ERROR,
  CLEAR_CREATE_PRODUCT_ERROR,
} from "../products/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";
import { clearForm } from "../form/actions";
import trimmedValues from "../../helper/trimmer";
// import { showSnackbarStatus } from "./snackbar.actions";

//--------------------------------PRODUCT-LIST------------------------------------------------
export const getProductsPending = () => ({
  type: GET_PRODUCTS_PENDING,
});

export const productListError = (errorMessage) => ({
  type: PRODUCT_LIST_ERROR,
  payload: { errorMessage },
});

const setProductsList = (productsOdata) => ({
  type: SET_PRODUCTS_LIST,
  payload: { productsOdata },
});

export const getProductsList = (page, currentPage, searchProductName, searchIsActive, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder) => (dispatch) => {
  dispatch(getProductsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Product.getProductData(accessToken, page, currentPage, searchProductName, searchIsActive, searchCreatedBy, searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder)
      .then((productList) => {
        dispatch(setProductsList(productList));
      })
      .catch((err) => {
        console.log("getProductsList server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(productListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(productListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//--------------------------------PRODUCT-CREATE----------------------------------------------
export const openCreateProductModal = () => ({
  type: OPEN_CREATE_PRODUCT_MODAL,
});

export const closeCreateProductModal = () => ({
  type: CLOSE_CREATE_PRODUCT_MODAL,
});

export const addProduct = (AddProductForm) => ({
  type: ADD_PRODUCT,
  payload: { AddProductForm },
});

export const createProductPending = () => ({
  type: CREATE_PRODUCT_PENDING,
});

export const createProductSuccess = () => ({
  type: CREATE_PRODUCT_SUCCESS,
});

export const createProductError = (errorMessage) => ({
  type: CREATE_PRODUCT_ERROR,
  payload: { errorMessage },
});

export const clearCreateProductError = () => ({
  type: CLEAR_CREATE_PRODUCT_ERROR,
});
const setAssignableProductsListForAsyncSelect = (productsList, searchValue) => ({
  type: SET_ASSIGNABLE_PRODUCTS_LIST_ASYNC,
  payload: { productsListAsync: productsList, searchValueAsync: searchValue },
});

export const createProduct = (AddProduct) => (dispatch) => {
  const values = trimmedValues(AddProduct);
  dispatch(createProductPending());
  getToken(dispatch).then((accessToken) => {
    agent.Product.create(accessToken, values)
      .then(() => {
        dispatch(clearCreateProductError());
        dispatch(createProductSuccess());
        dispatch(clearForm());
        dispatch(closeCreateProductModal());
        dispatch(getProductsList());
        dispatch(showSnackbarStatus("Product created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createProductError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createProductError(message));
        }
        console.log("createProduct server error", err);
        // dispatch(clearForm());
        // dispatch(createProductError(null));
        // dispatch(closeCreateProductModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getAssignableProductsForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Product.getAssignableProducts(accessToken, searchValue)
      .then((productList) => {
        let productsListOptions = modifyProductList(productList);
        dispatch(setAssignableProductsListForAsyncSelect(productsListOptions));
        callback && callback(productsListOptions);
      })
      .catch((err) => {
        console.log("getAssignableProductsForAsyncSelect for dropdown server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

//--------------------------------PRODUCT-EDIT------------------------------------------------
export const openUpdateProductModal = () => ({
  type: OPEN_UPDATE_PRODUCT_MODAL,
});

export const closeUpdateProductModal = () => ({
  type: CLOSE_UPDATE_PRODUCT_MODAL,
});

export const updateProductPending = () => ({
  type: UPDATE_PRODUCT_PENDING,
});

export const setProductDetails = (productDetails) => ({
  type: SET_PRODUCT_DETAILS,
  payload: { productDetails },
});

export const updateProductSuccess = () => ({
  type: UPDATE_PRODUCT_SUCCESS,
});

export const updateProductError = (errorMessage) => ({
  type: UPDATE_PRODUCT_ERROR,
  payload: { errorMessage },
});

export const clearUpdateProductError = () => ({
  type: CLEAR_UPDATE_PRODUCT_ERROR,
});

export const updateProduct = (data) => (dispatch) => {
  const values = trimmedValues(data);
  dispatch(updateProductPending());
  getToken(dispatch).then((accessToken) => {
    agent.Product.update(accessToken, values)
      .then(() => {
        dispatch(clearUpdateProductError());
        dispatch(updateProductSuccess());
        dispatch(clearForm());
        dispatch(closeUpdateProductModal());
        dispatch(getProductsList());
        dispatch(showSnackbarStatus("Product updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateProductError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateProductError(message));
        }
        console.log("updateProduct server error", err);
        //   dispatch(clearForm());
        // dispatch(updateProductError(null));
        // dispatch(closeUpdateProductModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};